import { render, staticRenderFns } from "./BaseTextArea.vue?vue&type=template&id=5dcbcf66&scoped=true"
import script from "./BaseTextArea.vue?vue&type=script&lang=js"
export * from "./BaseTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbcf66",
  null
  
)

export default component.exports